import React, {useEffect, useState} from 'react';
import {requestGetDVTJCUVPipeLineList} from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import DVTJCUVPipelineTableList, {DVTJCUVPipelineListMode} from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import {
    DVTJCUVSearchCddJobParentTabs,
    DVTJCUVSearchCddJobSetReceiverListTabs
} from "@pages/dvtjcuv/common/SearchCddJobTabs";
import {requestCheckBriefEmailCondition, requestStartRunDVTJCUV} from "@pages/dvtjcuv/service/DVTJCUVService";
import {DEFAULT_PAGE, DEFAULT_PAGE_SIZE, ORDER_BY, ResponseCode} from "@app/constants/Common";
import {EmailInviteMode} from "@pages/candidate/list/DVTJCUVEmailInviteModal";
import {alertMessage, showMessage} from "@app/constants/Messages";
import {processRequestCheckDVTJCUVEmailBrief} from "@pages/dvtjcuv/rundvtjcuv/RunDVUtil";
import CandidateListTable, {CandidateListMode} from "@pages/candidate/list/CandidateListTable";
import {requestCandidates} from "@app/services/CandidateService";
import {doExportExcel} from "@app/utils/CommonUtils";

const ReceiversAutoReleasedTabs = {
    BOSS_TAB: {title: 'Boss', id: 'boss-tab'},
    HRD_HRM_TAB: {title: 'HRD, HRM', id: 'hrd-hrm-tab'},
    RECRUITER_TAB: {title: 'Recruiter', id: 'recruiter-tab'},
    OTHER_HR_STAFF_TAB: {title: 'Other HR Staff', id: 'other-hr-staff-tab'},
    HIRING_MGR_TAB: {title: 'Hiring Mgr', id: 'hiring-mgr-tab'},
    HIRING_MGR_1_TAB: {title: 'Hiring Mgr dự phòng 1', id: 'hiring-mgr-1-tab'},
    HIRING_MGR_2_TAB: {title: 'Hiring Mgr dự phòng 2', id: 'hiring-mgr-2-tab'},
    CDD_RELATED: {title: 'Cdd Related', id: 'cdd-related-tab'}
};

const DVTJCUVReceiversAutoReleasedTabContent = (props) => {
    const [currentTab, setCurrentTab] = useState(ReceiversAutoReleasedTabs.BOSS_TAB);
    // const [pipelineList, setPipelineList] = useState([]);
    const [candidates, setCandidates] = useState([]);
    // const [selectedPipelines, setSelectedPipelines] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);

    const {cddId, onChangeRootTab} = props

    const parentTab = DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_AUTO_RELEASED_TAB

    // const fetchPipeLines = async (pTab, subTab, sorts) => {
    //     const params = {
    //         search_conditions: {
    //             parent_tab: pTab?.id,
    //             sub_tab: subTab?.id,
    //             cdd_id: cddId,
    //             unlimited: true
    //         },
    //         sort_columns: sorts
    //     }
    //
    //     const res = await requestGetDVTJCUVPipeLineList(params);
    //     const resContent = res.content
    //     setPipelineList(resContent.pipelines)
    //
    // }

    const fetchCandidateList = async (pTab, sTab, page, isExportExcel, candidateIds=[]) => {
        const params = {page: page > 0 ? page : DEFAULT_PAGE,
            size: DEFAULT_PAGE_SIZE, order_by: ORDER_BY.DESC_UPDATE_DATE,
            search_conditions: {
                search_cdd_job_mode: true,
                parent_tab: pTab ? pTab.id : "",
                sub_tab: sTab.id,
                unlimited: true
            }
        }

        if (cddId) {
            params.search_conditions.cdd_id = cddId;
        }

        if (isExportExcel) {
            params.is_export_excel = isExportExcel
        }

        const res = await requestCandidates(params);
        if (isExportExcel) {
            doExportExcel(res.content.candidates)
        }
        setCandidates(res.content.candidates);
        setTotalCount(res.content.totalCount)
    }

    useEffect(() => {
        console.log('parentTab', parentTab)
        fetchCandidateList(parentTab, currentTab)
    }, []);

    const onTabClicked = async (tab) => {
        setCurrentTab({...tab});
        await fetchCandidateList(parentTab, tab)
    };

    const activeTab = (tab) => {
        if (currentTab.id === tab.id) {
            return 'active'
        }
        return ''
    }

    const onSelectCandidates = (canIds) => {
      setSelectedCandidateIds(canIds)
    }

    const onStartCheckEmailBriefConditions = async (condition = {}) => {
        condition.candidate_id = cddId
        condition.receiver_ids = []
        selectedCandidateIds.forEach(canId => {
            if (canId) {
                condition.receiver_ids.push(canId)
            }
        })
        const result = await processRequestCheckDVTJCUVEmailBrief(condition)
        if (result) {
            onChangeRootTab(DVTJCUVSearchCddJobParentTabs.SEND_EMAIL_BRIEF_UV_TAB)
        }
    }

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Receivers AUTO Released</h3>
                <div className={'card-tools'}>
                    <button type='button'
                            className='btn btn-info btn-sm'
                            disabled={selectedCandidateIds.length === 0}
                            onClick={() =>
                                onStartCheckEmailBriefConditions()
                            }
                    >
                        Gửi Email Brief UV
                    </button>
                </div>
            </div>
            <div className='card-body'>
                <ul className='nav nav-tabs' role='tablist'>
                    {Object.values(ReceiversAutoReleasedTabs).map(tab => (
                        <li className='nav-item' key={`DVTJCUVReceiversAutoReleasedContent-tab-item-${tab.id}`}>
                            <a className={`nav-link ${activeTab(tab)}`} data-toggle='tab' href={`#${tab.id}`}
                               onClick={() => onTabClicked(tab)}>{tab.title}
                            </a>
                        </li>
                    ))}
                </ul>
                <div className='tab-content'>
                    {Object.values(ReceiversAutoReleasedTabs).map((tab, index) => {
                        if (currentTab.id === tab.id) {
                            return <div id={tab.id} className={`tab-pane ${activeTab(tab)}`}
                                        style={{height: '83vh', overflow: 'auto'}}
                                        key={`DVTJCUVReceiversAutoReleasedContent-sub-tab-content-${tab.id}`}>
                                {/*<DVTJCUVPipelineTableList*/}
                                {/*    showBtnSelect*/}
                                {/*    cddId={cddId}*/}
                                {/*    onSelectItems={onSelectPipelines}*/}
                                {/*    pipeLines={pipelineList}*/}
                                {/*    mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_SEARCH_JOB_CDD}*/}
                                {/*    parentTabId={DVTJCUVSearchCddJobParentTabs.SET_RECEIVER_LIST_TAB.id}*/}
                                {/*    subTabId={DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_AUTO_RELEASED_TAB.id}*/}
                                {/*/>*/}
                                <CandidateListTable
                                    showBtnSelect
                                    hideBtnActions
                                    candidates={candidates}
                                    onReturnSelectedItems={onSelectCandidates}
                                    // allCandidateIds={allCandidateIds}
                                    mode={CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_RECEIVER_AUTO_RELEASE}
                                    totalCount={totalCount}
                                    // onDelete={onDeleteReceivers}
                                />
                            </div>
                        }
                        return "";
                    })}
                </div>
            </div>
        </div>
    )
}

export default DVTJCUVReceiversAutoReleasedTabContent;
